// Mock data for GFA Telecom website

export const cities = [
  { id: 1, name: "Corguinho", available: true },
  { id: 2, name: "Rio Negro", available: true },
  { id: 3, name: "Rochedo", available: true },
  { id: 4, name: "São Gabriel do Oeste", available: true }
];

export const plans = [
  {
    id: 1,
    name: "Essencial",
    speed: 500,
    unit: "MEGA",
    price: 109.90,
    features: [
      "Wi-Fi Grátis",
      "100% Fibra Óptica",
      "Suporte Dedicado",
      "Download Ilimitado",
      "Instalação Grátis"
    ],
    popular: false,
    color: "from-blue-500 to-cyan-400"
  },
  {
    id: 2,
    name: "Avançado",
    speed: 750,
    unit: "MEGA",
    price: 139.90,
    features: [
      "Wi-Fi Grátis",
      "100% Fibra Óptica",
      "Suporte Dedicado",
      "Download Ilimitado",
      "Instalação Grátis",
      "Roteador Dual Band"
    ],
    popular: true,
    color: "from-cyan-400 to-blue-500"
  },
  {
    id: 3,
    name: "Ultra",
    speed: 1000,
    unit: "MEGA",
    price: 189.90,
    features: [
      "Wi-Fi Grátis",
      "100% Fibra Óptica",
      "Suporte Dedicado Prioritário",
      "Download Ilimitado",
      "Instalação Grátis",
      "Roteador Mesh",
      "IP Fixo Disponível"
    ],
    popular: false,
    color: "from-blue-600 to-indigo-500"
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Zap",
    title: "Ultra Velocidade",
    description: "Conexão de alta performance para streaming, games e trabalho sem travamentos.",
    stat: "1GB",
    statLabel: "Máximo"
  },
  {
    id: 2,
    icon: "Shield",
    title: "Conexão Estável",
    description: "Fibra óptica 100% dedicada, sem quedas ou oscilações de sinal.",
    stat: "99.9%",
    statLabel: "Uptime"
  },
  {
    id: 3,
    icon: "Headphones",
    title: "Suporte Dedicado",
    description: "Equipe técnica especializada pronta para atender você.",
    stat: "Top",
    statLabel: "Serviço"
  },
  {
    id: 4,
    icon: "Wifi",
    title: "Wi-Fi Premium",
    description: "Roteador de última geração incluso em todos os planos.",
    stat: "Mesh",
    statLabel: "Tech"
  },
  {
    id: 5,
    icon: "Infinity",
    title: "Sem Limites",
    description: "Download ilimitado. Use à vontade sem preocupações.",
    stat: "∞",
    statLabel: "GB"
  },
  {
    id: 6,
    icon: "Rocket",
    title: "Instalação Express",
    description: "Agendamento flexível com instalação em até 48 horas.",
    stat: "48h",
    statLabel: "Máx"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Como verificar a disponibilidade na minha região?",
    answer: "Você pode verificar a disponibilidade selecionando sua cidade no topo do site ou entrando em contato pelo WhatsApp. Nossa equipe irá confirmar se atendemos seu endereço."
  },
  {
    id: 2,
    question: "Qual é o prazo de instalação?",
    answer: "Após a confirmação do pedido, a instalação é realizada em até 48 horas úteis, com agendamento conforme sua disponibilidade."
  },
  {
    id: 3,
    question: "Existe fidelidade no contrato?",
    answer: "Não temos fidelidade! Todo contrato pode ser cancelado a qualquer momento sem multas, garantindo o ótimo atendimento e prestação do serviço."
  },
  {
    id: 4,
    question: "O roteador Wi-Fi está incluso?",
    answer: "Sim! Todos os nossos planos incluem roteador Wi-Fi de qualidade, instalado gratuitamente em sua residência ou empresa."
  },
  {
    id: 5,
    question: "Como funciona o suporte técnico?",
    answer: "Oferecemos suporte técnico dedicado via WhatsApp, telefone e central do assinante. Nossa equipe está pronta para resolver qualquer problema."
  },
  {
    id: 6,
    question: "Posso fazer upgrade do meu plano?",
    answer: "Sim! Você pode fazer upgrade do seu plano a qualquer momento, sem custo adicional de instalação. Basta entrar em contato conosco."
  }
];

export const companyInfo = {
  name: "GFA Telecom",
  logo: "https://customer-assets.emergentagent.com/job_c490d8a0-239e-451a-9b96-14f5bfae88e1/artifacts/dzh6lfm7_GFA-Telecom-2.png",
  phone: "(67) 99807-7361",
  whatsapp: "5567998077361",
  email: "contato@gfanet.com.br",
  website: "www.gfanet.com.br",
  centralAssinante: "https://gfanet.com.br/cliente",
  address: "Mato Grosso do Sul",
  horarios: {
    semana: "Seg a Sex 07:00 às 11:00 e 13:00 às 17:30",
    sabado: "Sáb 07:30 às 11:00"
  },
  socialMedia: {
    facebook: "https://facebook.com/gfatelecom",
    instagram: "https://instagram.com/gfatelecom"
  }
};
